import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, map, tap } from 'rxjs';

import { ApiResponse } from '@/core/models/response.model';
import { apiRoutes } from '@/environments/apis/api-routes';
import { LocalStorageService } from '@/core/services/local-storage.service';
import { RefreshTokenRequest, RefreshTokenResponse } from '../interfaces/auth.interface';

const DEFAULT_TOKEN_EXPIRY_SECONDS = 900;

@Injectable({ providedIn: 'root' })
export class AuthService {
  private readonly http = inject(HttpClient);
  private readonly localStorage = inject(LocalStorageService);

  refreshToken(): Observable<RefreshTokenResponse> {
    const refreshToken = this.localStorage.getRefreshToken();
    if (!refreshToken) {
      throw new Error('No refresh token available');
    }

    const payload: RefreshTokenRequest = { RefreshToken: refreshToken };

    return this.http
      .post<ApiResponse<RefreshTokenResponse>>(
        apiRoutes.gateway.mobileAuth.refreshToken,
        payload,
      )
      .pipe(
        map((response) => {
          if (!response.Status || !response.Data) {
            throw new Error(
              response.Errors?.[0] ||
                response.ProblemDetails?.detail ||
                'Token refresh failed',
            );
          }

          return response.Data;
        }),
        tap((response) => {
          if (response.AccessToken && response.RefreshToken) {
            this.localStorage.setAccessToken(response.AccessToken);
            this.localStorage.setRefreshToken(response.RefreshToken);
            this.localStorage.setTokenExpiry(
              Date.now() +
                (response.ExpiresIn ?? DEFAULT_TOKEN_EXPIRY_SECONDS) * 1000,
            );
          }
        }),
      );
  }

  logout(): void {
    this.localStorage.clear();
  }
}
